import { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { csValidTimeVisibleState } from "../../store/CsValidTimeVisibleState";
import FlightPathModeState from "../../store/FlightPathModeState";
import { selectedWeatherList, WX_ID_ACOS, WX_ID_ASCSCALE, WX_ID_UKMET } from "../../store/WeatherContentsState";
import { makeStyles } from "@material-ui/core";
import { TinySwitch } from "../../parts/TinySwitch";

const targetList = [
  WX_ID_UKMET,
  WX_ID_ASCSCALE,
  WX_ID_ACOS
]

const useStyles = makeStyles(() => ({
  toggleValid: {
    cursor: "pointer"
  },
  toggleValidtime: {
    position: "absolute",
    top: 4,
    right: 4
  }
}));

function ToggleValidTime() {
  const [validVisible, setValidVisible] = useRecoilState(csValidTimeVisibleState);
  const flightPathMode = useRecoilValue(FlightPathModeState);
  const [hidden, setHidden] = useState(true);
  const selectedWeather = useRecoilValue(selectedWeatherList);
  const classes = useStyles();

  function onClickHandler() {
    setValidVisible(!validVisible);
  }

  useEffect(() => {
    if(flightPathMode) {
      let hidden = true;
      for(let target of targetList) {
        if(selectedWeather.includes(target)) {
          hidden = false;
          break;
        }
      }
      setHidden(hidden);
    } else {
      setHidden(true);
    }
  }, [flightPathMode, selectedWeather, setHidden]);

  return (
    <div className={classes.toggleValidtime} hidden={hidden}>
      <TinySwitch checked={validVisible} onChange={onClickHandler} className={classes.toggleValid} id="hoge"/>
    </div>
  );
}

export default ToggleValidTime;